import Cleave from '../plugins/cleave'

/**
 * Shared base mixin for Cleave-backed form inputs (masked/formatted fields).
 * Superset of the aven_my and aven_notary copies: exposes both `validation` and
 * `validationRules` so either app's call sites resolve, and standardizes on the
 * aven_shared cleave wrapper.
 */
export const formInputCleaveMixin = {
    props: {
        name: { type: String, required: true },
        value: { type: String, default: null },
        validation: { type: String, default: null },
        validationRules: { type: String, default: null },
        label: { type: String, default: null },
        formClasses: { type: String, default: null },
        placeholder: { type: String, default: null },
        focusPlaceholder: { type: String, default: null },
        autocomplete: { type: String, default: null },
        autofocus: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        validationMode: {
            type: String,
            default: 'lazy',
            validator: function (value) {
                return ['eager', 'aggressive', 'passive', 'lazy'].indexOf(value) !== -1
            },
        },
    },
    components: {
        cleave: Cleave,
        // validation-provider is intentionally registered by each app's own formInputMixin, not here.
        // importing vee-validate from aven_shared binds a second module instance whose rule registry is
        // empty (apps extend rules on their own instance), so validation would silently pass.
    },
    created: function () {
        this.cleaveValue = this.value
    },
    data: function () {
        return {
            cleaveValue: null,
            dynamicPlaceholder: this.placeholder,
        }
    },
    watch: {
        cleaveValue: function (value) {
            this.$emit('input', value)
        },
    },
    methods: {
        setFocus: function () {
            this.$nextTick(() => this.$refs.formFieldInput.$el.focus())
        },
        clearValue: function () {
            this.cleaveValue = null
        },
    },
}
